export enum ApprovalStatus {
  ALL = '',
  WAIT = 0,
  PASSED,
  REJECT,
}
export interface ApprovalFormItem {
  releaseId: number;
  approvalStatus: number;
  rejectReason?: string;
}
